import { endOfDay } from 'date-fns';
import { DateRangeValuePiece } from 'common/components/Inputs/DateRangePickerMui/DateRangePickerMui.tsx';

export const parseDateRange = ({
  from,
  to,
}: {
  from: DateRangeValuePiece;
  to: DateRangeValuePiece;
}) => {
  const uploadDateFrom = from;
  const uploadDateTo = to;

  const hasFromDateOnly = uploadDateFrom !== null && uploadDateTo === null;
  const hasToDateOnly = uploadDateTo !== null && uploadDateFrom === null;
  const hasBoth = uploadDateFrom !== null && uploadDateTo !== null;

  const isValidRange =
    hasFromDateOnly || hasToDateOnly || (hasBoth && endOfDay(uploadDateTo) > uploadDateFrom);

  return {
    from: from && isValidRange ? from : null,
    to: to && isValidRange ? endOfDay(to) : null,
  };
};
